export default { sha: '2b0bc63e8e7f0351b555e767037da2101afd44f5', buildNumber: 'undefined' }
